import { useNavigate } from "react-router-dom";
import { Card, CardBody } from "reactstrap";

interface DealCardProps {
  deal: {
    id: string;
    title: string;
    priceFrom: number | null;
    priceNew: number;
    photoUrl: string;
    dealUrl: string;
    category?: string;
  };
}

export default function DealCard({ deal }: DealCardProps) {
  const navigate = useNavigate();

  return (
    <Card
      className="h-100 border-0 shadow-sm"
      style={{
        cursor: "pointer",
        borderRadius: "12px",
        overflow: "hidden",
        transition: "transform 0.2s ease, box-shadow 0.2s ease"
      }}
      onClick={() => navigate(deal.dealUrl)}
    >
      {/* Image Container */}
      <div
        style={{
          height: "140px",
          backgroundImage: `url(${deal.photoUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundColor: "#f8f9fa"
        }}
      />

      {/* Content */}
      <CardBody className="p-3">
        <h6
          className="mb-2"
          style={{
            fontSize: "14px",
            fontWeight: "600",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
        >
          {deal.title}
        </h6>
        <div style={{ fontSize: "14px" }}>
          {deal.priceFrom && Number(deal.priceFrom) > Number(deal.priceNew) ? (
            <div className="d-flex align-items-center flex-wrap">
              <span
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  textDecoration: "line-through"
                }}
              >
                ${Number(deal.priceFrom).toFixed(2)}
              </span>
              <span
                style={{
                  fontWeight: "700",
                  color: "#27ae60",
                  marginLeft: "8px"
                }}
              >
                ${Number(deal.priceNew).toFixed(2)}
              </span>
            </div>
          ) : (
            <span style={{ fontWeight: "700" }}>
              ${Number(deal.priceNew).toFixed(2)}
            </span>
          )}
        </div>
      </CardBody>
    </Card>
  );
}
